import React, { useState } from "react";
import { Link } from "react-router-dom";
// Icons
import { FaPaperPlane, FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn } from "react-icons/fa";

const Footer = () => {
  const [email, setEmail] = useState("");
  // Initial state logic same hai
  const [status, setStatus] = useState({ loading: false, msg: "" });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;

    setStatus({ loading: true, msg: "" });

    const payload = {
      firstName: "Newsletter Subscriber",
      email: email,
      phone: "N/A",
      subject: "New Newsletter Subscription",
      message: "This user wants to subscribe to the newsletter.",
    };

    try {
      const response = await fetch("http://localhost:5000/send-email", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        setStatus({ loading: false, msg: "Subscribed Successfully!" });
        setEmail(""); 
        // 5 Second ka time diya taake user araam se parh le
        setTimeout(() => setStatus({ loading: false, msg: "" }), 5000);
      } else {
        setStatus({ loading: false, msg: "Subscription Failed." });
      }
    } catch (error) {
      setStatus({ loading: false, msg: "Server Error. Try again." });
    }
  };

  return (
    <div className="it-newsletter-area it-newsletter-style-2">
      {/* --- Newsletter Section --- */}
      <div className="container">
        <div
          className="it-newsletter-wrap theme-bg z-index-2 wow itfadeUp"
          data-wow-duration=".9s"
          data-wow-delay=".3s"
        >
          <img
            className="it-newsletter-shape-1"
            src="assets/img/shape/newsletter-2-1.png"
            alt=""
          />
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="it-newsletter-2-left">
                <h4 className="it-newsletter-2-title text-white mb-0">
                  Sign Up today to get the <br /> latest inspiration & insights
                </h4>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="it-newsletter-input-box">
                
                <form className="input-wrap p-relative" onSubmit={handleSubmit}>
                  <input
                    type="email"
                    placeholder="Enter your Email Address"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                  <button type="submit" disabled={status.loading}>
                    <FaPaperPlane size={18} />
                  </button>
                </form>

                {/* --- YAHAN CHANGE KIYA HAI (Message Box Style) --- */}
                {status.msg && (
                  <div style={{
                    marginTop: "15px",
                    padding: "10px",
                    // Agar Success hai to Green, warna Red background
                    backgroundColor: status.msg.includes("Success") ? "#28a745" : "#ff4757",
                    color: "white",
                    borderRadius: "5px",
                    textAlign: "center",
                    fontWeight: "bold",
                    boxShadow: "0px 4px 10px rgba(0,0,0,0.2)"
                  }}>
                    {status.loading ? "Sending..." : status.msg}
                  </div>
                )}
                {/* ------------------------------------------------ */}

              </div>
            </div>
          </div>
        </div>
      </div>

      {/* --- Footer Main Section --- */}
      <footer>
        <section className="it-footer-wrap gray-bg it-footer-style-2 fix">
          <div
            className="it-footer-area z-index-1 pt-200 pb-50"
            data-background="assets/img/shape/footer-bg-2-1.jpg"
          >
            <img
              className="it-footer-shape-1"
              src="assets/img/shape/footer-2-1.png"
              alt=""
            />
            <img
              className="it-footer-shape-2"
              src="assets/img/shape/footer-2-2.png"
              alt=""
            />
            <div className="it-footer-border">
              <span></span>
            </div>
            <div className="container">
              <div className="row">
                
                {/* Column 1 */}
                <div
                  className="col-xl-3 col-lg-3 col-md-6 col-sm-6 mb-50 wow itfadeUp"
                  data-wow-duration=".9s"
                  data-wow-delay=".3s"
                >
                  <div className="it-footer-widget it-footer-col-1-1">
                    <div className="it-footer-widget-logo mb-30">
                      <a href="index.html">
                        <img src="assets/img/logo/logo.png" alt="" width="100px" />
                      </a>
                    </div>
                    <div className="it-footer-widget-text">
                      <p>
                        Quick Class Takers is built to support students who struggle to manage online classes, exams, quizzes, and assignments.
                      </p>
                    </div>
                    <div className="it-footer-widget-btn">
                      <Link to="/contact" className="it-btn-yellow theme-bg">
                        <span>
                          <span className="text-1">Contact Us</span>
                          <span className="text-2">Contact Us</span>
                        </span>
                        <i>
                           <FaPaperPlane />
                        </i>
                      </Link>
                    </div>
                  </div>
                </div>

                {/* Column 2 */}
                <div
                  className="col-xl-3 col-lg-3 col-md-6 col-sm-6 mb-50 wow itfadeUp"
                  data-wow-duration=".9s"
                  data-wow-delay=".5s"
                >
                  <div className="it-footer-widget it-footer-col-1-2">
                    <h4 className="it-footer-widget-title">Quick Link</h4>
                    <div className="it-footer-widget-menu">
                      <ul>
                        <li><Link to="/">Home</Link></li>
                        <li><Link to="/about">About</Link></li>
                        <li><Link to="/online-class">Online Class</Link></li>
                        <li><Link to="/online-exams">Online Exams</Link></li>
                        <li><Link to="/online-assignment">Online Assignment</Link></li>
                      </ul>
                    </div>
                  </div>
                </div>

                {/* Column 3 */}
                <div
                  className="col-xl-3 col-lg-3 col-md-6 col-sm-6 mb-50 wow itfadeUp"
                  data-wow-duration=".9s"
                  data-wow-delay=".7s"
                >
                  <div className="it-footer-widget it-footer-col-1-3">
                    <h4 className="it-footer-widget-title">Support</h4>
                    <div className="it-footer-widget-menu">
                      <ul>
                        <li><Link to="/contact">Contact Us</Link></li>
                        <li><Link to="/">Privacy Policy</Link></li>
                        <li><Link to="/">Terms & Conditions</Link></li>
                      </ul>
                    </div>
                  </div>
                </div>

                {/* Column 4 */}
                <div
                  className="col-xl-3 col-lg-3 col-md-6 col-sm-6 mb-50 wow itfadeUp"
                  data-wow-duration=".9s"
                  data-wow-delay=".9s"
                >
                  <div className="it-footer-widget it-footer-col-1-4 d-flex justify-content-lg-end">
                    <div>
                      <h4 className="it-footer-widget-title">Get Contact</h4>
                      <div className="it-footer-widget-contact mb-25">
                        <ul>
                          <li>
                            <span>Phone:</span>
                            <a href="tel:+13059023242">+1 (305) 902-3242</a>
                          </li>
                          <li>
                            <span>Email:</span>
                            <a href="mailto:info@quickclasstakers.com">info@quickclasstakers.com</a>
                          </li>
                          <li>
                            <span>Location:</span>
                            610 E 20th St, New York, NY 10009, USA
                          </li>
                        </ul>
                      </div>
                      
                      <div className="it-footer-widget-social">
                        <a href="#"><FaFacebookF size={18} /></a>
                        <a href="#"><FaTwitter size={18} /></a>
                        <a href="#"><FaInstagram size={18} /></a>
                        <a href="#"><FaLinkedinIn size={18} /></a>
                      </div>

                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>

          <div className="it-copyright-area it-copyright-ptb it-copyright-bg z-index-1 black-bg">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-12">
                  <div className="it-copyright-left text-center">
                    <p className="mb-0">
                      Copyright © 2025 <Link to="/">Quick Class Takers</Link> All Rights Reserved
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </footer>
    </div>
  );
};

export default Footer;